import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Outlet,
} from "react-router-dom";
import FallbackLoader from "../components/fallbackLoader";
import { AuthProvider } from "../auth/auth";
import ViewPolicyPaper from "../components/policyPaper";
import ThirdPartyLogin from "../auth/thirdPartyLogin";
import DashboardLayout from "../layouts/dashboardLayout";
import ForgetPassoword from "../auth/forgetPassoword";
import Kyc from "../pages/kyc";
import ForeignEmploymentPolicyPaper from "../components/policyPaper/ForeignEmploymentPolicyPaper";
import ScrollToTop from "../ScrollToTop";
import TermLifeInsurancePolicyPaper from "../components/policyPaper/termLifeInsurancePolicyPaper";
import ImeGeneratePolicy from "../GeneratePolicy/ImeGeneratePolicy";
import PolicyPaperPreview from "../report/PolicyPaper";
import ELoan from "../pages/eLoan/eLoan";
import ChangePassword from "../auth/changePassword";
import NpxGeneratePolicy from "../GeneratePolicy/NpxGeneratePolicy";
import KhaltiGeneratePolicy from "../GeneratePolicy/KhaltiGeneratePolicy";
import RevivePolicy from "../pages/lapsedPolicies/RevivePolicy.tsx";
import RevivedPoliciesList from "../pages/lapsedPolicies/RevivedPoliciesList.tsx";
import RevivedPolicyDetail from "../pages/lapsedPolicies/RevivedPolicyDetail.tsx";

const RiderPaperPreview = lazy(() => import("../report/RiderPaper"));
const LapsedPoliciesIndex = lazy(() => import("../pages/lapsedPolicies/lapsedPolicies"));

const TermsAndConditions = lazy(() => import("../pages/termsAndConditions"));
const ChangeExpirePassword = lazy(() => import("../auth/changeExpirePassword"));
const ForeignEmployment = lazy(() => import("../pages/foreignEmployment"));
const Dashboard = lazy(() => import("../pages/dashboard"));
const DeletedPolicies = lazy(() => import("../pages/policies/deletedPolicies"));
const EditPolicies = lazy(() => import("../pages/policies/editPolicies"));
const TermLifeInsuranceReceipt = lazy(() =>
  import("../components/receipt/termLifeInsuranceReceipt")
);
const PoliciesIndex = lazy(() => import("../pages/policies"));
const Index = lazy(() => import("../pages"));
const Login = lazy(() => import("../auth/login"));
const Register = lazy(() => import("../auth/register"));
const DashBoardLife = lazy(() => import("../lifeView"));
const Layout = lazy(() => import("../layouts/Layout"));
const EsewaPayment = lazy(() => import("../eSewa/esewaPayment"));

export default function AppRouter() {
  return (
    <Suspense fallback={<FallbackLoader />}>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* All public route */}
          <Route
            path="/third-party-login"
            element={<ThirdPartyLogin />}
            exact
          />
          <Route
            exact
            path="/esewa-online-payment"
            element={<EsewaPayment />}
          />
          <Route
            exact
            path="/payment-status"
            element={<EsewaPayment />}
          />
          <Route
            exact
            path="/term-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route exact path="/login" element={<Login />} />

          <Route exact path="/register" element={<Register />} />
          <Route exact path="/forget-password" element={<ForgetPassoword />} />
          <Route
            exact
            path="/change-expired-password"
            element={<ChangeExpirePassword />}
          />

          {/* All route for outside dashboard but auth required */}
          <Route
            exact
            path="/"
            element={
              <AuthProvider>
                <Outlet />
              </AuthProvider>
            }
          >
            <Route exact path="/buy-life-insurance" element={<Index />} />
            <Route exact path="/policy-paper" element={<ViewPolicyPaper />} />
            <Route
              exact
              path="/receipt"
              element={<TermLifeInsuranceReceipt />}
            />
          </Route>

          {/* All Route inside dashboard */}
          <Route
            exact
            path="/"
            element={
              <AuthProvider>
                <DashboardLayout>
                  <Outlet />
                </DashboardLayout>
              </AuthProvider>
            }
          >
            <Route exact path="/change-password" element={<ChangePassword />} />

            <Route index exact element={<Dashboard />} />
            <Route exact path="/dashboard" element={<Dashboard />} />
            <Route exact path="/policies" element={<PoliciesIndex />} />
            <Route exact path="/e-loan" element={<ELoan />} />
            <Route exact path="/kyc" element={<Kyc />} />
            <Route
              exact
              path="/deleted/policies"
              element={<DeletedPolicies />}
            />
            <Route exact path="/policies/edit/:id" element={<EditPolicies />} />
            <Route
              exact
              path="/foreign-employment"
              element={<ForeignEmployment />}
            />
            <Route
              exact
              path="/online-ime-generate-policy/"
              element={<ImeGeneratePolicy />}
            />
            <Route
              exact
              path="/online-npx-generate-policy"
              element={<NpxGeneratePolicy />}
            />
            <Route
              exact
              path="khalti-online-proforma-payment"
              element={<KhaltiGeneratePolicy />}
            />
            <Route
              exact
              path="/report/policy-paper-preview"
              element={<PolicyPaperPreview />}
            />
            <Route
              exact
              path="/report/rider-paper-preview"
              element={<RiderPaperPreview />}
            />
            <Route
              exact
              path="/lapsed-policies"
              element={<LapsedPoliciesIndex />}
            />
            <Route
              path="/lapsed-policies/revive-policy"
              element={<RevivePolicy />}
            />
             <Route
              path="/revived-policies/all"
              element={<RevivedPoliciesList />}
            />
            <Route
              exact
              path="/revived-policies/:policyNo"
              element={<RevivedPolicyDetail />}
            />
          </Route>

          {/* <Route
            exact
            path="/dofe-policypaper"
            element={<ForeignEmploymentPolicyPaper />}
          /> */}
        </Routes>
      </Router>
    </Suspense>
  );
}
